import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'app-excell-column-cell-viewer',
    templateUrl: './excell-column-cell-viewer.component.html',
    styleUrls: ['./excell-column-cell-viewer.component.scss']
})
export class ExcelColumnCellViewerComponent implements OnInit, CellComponent {
    fieldDefinition: FieldDefinition;
    item: any;
    @Output() valueChanged?: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    onSetPrimaryKeyClicked() {
        const value = this.item.cells['IsPrimaryKey'].value;
        const isTrialBalance = this.item.cells['IsTrialBalance']?.value;
        if (value === false && isTrialBalance === false) {
            this.item.cells['IsPrimaryKey'].value = !value;
            this.valueChanged.emit({item: this.item, key: 'IsPrimaryKey', action: {id: 'Update'}});
        }
    }

    onIconClicked(fieldKey) {
        const value = this.item.cells[fieldKey].value;
        this.item.cells[fieldKey].value = !value;
        this.valueChanged.emit({item: this.item, key: fieldKey, action: {id: 'Update'}});
    }
}
